import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconChevronLeft from './nav-icon-chevron-left.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconChevronLeft {...validProps} />;
}
SvgComponent.iconName = 'navIconChevronLeft';

/**
 * @deprecated This is a legacy icon
 */
export const NavIconChevronLeftIcon = svgIconWrapper(SvgComponent);
